export default "__VITE_ASSET__e7d58a0f__"